import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { GlobalConstants } from '../global-constant';
@Injectable()
export class AuthService {
  public apiBaseURL = GlobalConstants.apiURL;
  constructor(public afAuth: AngularFireAuth, private http: HttpClient) {}

  // Facebook login
  doFacebookLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.FacebookAuthProvider();
      this.afAuth.auth.signInWithPopup(provider).then(
        res => {
          resolve(res);
        },
        err => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  // Github login
  doGitHubLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.GithubAuthProvider();
      this.afAuth.auth.signInWithPopup(provider).then(
        res => {
          resolve(res);
        },
        err => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  // Twitter login
  doTwitterLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.TwitterAuthProvider();
      this.afAuth.auth.signInWithPopup(provider).then(
        res => {
          resolve(res);
        },
        err => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  // Google login
  doGoogleLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      this.afAuth.auth.signInWithPopup(provider).then(
        res => {
          resolve(res);
        },
        err => {
          console.log(err);
          reject(err);
        }
      );
    });
  }

  // Register
  doRegister(value) {
    return new Promise<any>((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(value.email, value.password)
        .then(
          res => {
            resolve(res);
          },
          err => reject(err)
        );
    });
  }

  // Login
  doLogin(value) {
    // return new Promise<any>((resolve, reject) => {
    //   firebase
    //     .auth()
    //     .signInWithEmailAndPassword(value.email, value.password)
    //     .then(
    //       res => {
    //         resolve(res);
    //       },
    //       err => reject(err)
    //     );
    // });
    return this.http.post(`${this.apiBaseURL}/Token`, value);
  }

  getUserProfile(id) {
    return this.http.get(`${this.apiBaseURL}/User/GetUserProfile?UserID=${id}`);
  }

  resetPassword(value) {
    return this.http.post(`${this.apiBaseURL}/User/Reset`, value);
  }

  getPasswordMail(obj) {
    return this.http.get(`${this.apiBaseURL}/User/TriggerResetEmail?UserName=${obj.userName}`);
  }

  // Logout
  doLogout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('remember');
    localStorage.removeItem('userID');
    window.location.href = '';
    // return new Promise((resolve, reject) => {
    //   if (firebase.auth().currentUser) {
    //     localStorage.removeItem('currentUser');
    //     localStorage.removeItem('remember');
    //     this.afAuth.auth.signOut();
    //     //resolve();
    //   } else {
    //     localStorage.removeItem('currentUser');
    //     //resolve();
    //   }
    // });
  }
}
